/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';

import { DedicatedFinetuningOutputModelsDocument } from '@fai/friendli-suite/generated/client/graphql';

export const useFinetuningOutputModels = () => {
  const { finetuningId = '' } = useParams();

  const {
    data: _data,
    loading,
    startPolling,
    stopPolling,
  } = useQuery(DedicatedFinetuningOutputModelsDocument, {
    variables: { finetuningId },
    fetchPolicy: 'cache-and-network',
  });

  const data = _data?.dedicatedFinetuning?.adapters?.edges.map(({ node }) => ({
    id: node.id,
    createdAt: node.createdAt,
  }));
  const totalCount = _data?.dedicatedFinetuning?.adapters?.totalCount ?? 0;

  return { data, totalCount, loading, startPolling, stopPolling };
};
